<svg
  xmlns="http://www.w3.org/2000/svg"
  id="svg-source"
  style="position: fixed; width: 0; height: 0"
>
  <symbol id="trash-white-icon" viewBox="0 0 28 28">
    <g id="trash-Save-a-card" stroke="none" stroke-width="1" fill="none">
      <g
        id="trash-04_Pay-portal---Saved-card"
        transform="translate(-297.000000, -279.000000)"
      >
        <g
          id="trash-Design/Icon/Delete"
          transform="translate(297.000000, 279.000000)"
        >
          <g id="trash-Colour/Jungle">
            <path
              d="M7,12 C7,11.4477153 7.44771525,11 8,11 C8.55228475,11 9,11.4477153 9,12 L9,20.0480347 C9,20.7048476 9.24606432,20.9426724 10.0195923,21 L18.0003662,21 C18.7864986,21 19,20.7915881 19,20.0480347 L19,12 C19,11.4477153 19.4477153,11 20,11 C20.5522847,11 21,11.4477153 21,12 L21,20.0480347 C21,21.9071016 19.8804122,23 18.0003662,23 L9.94890011,22.9974982 C8.10033053,22.866491 7,21.8030056 7,20.0480347 L7,12 Z"
              id="trash-Path-4"
              fill="#fff"
            ></path>
            <path
              d="M12,9.02941895 L10,9.02941895 L10,8.04272461 C10,6.1404144 11.1192498,5.01267322 13.0273437,5 L15.0565294,5.00088252 C16.9176887,5.07912588 18.0166016,6.17803872 18.0166016,8.0020752 L18.0166016,9.02941895 L16.0166016,9.02941895 L16.0166016,8.0020752 C16.0166016,7.26890138 15.7807976,7.03309743 15.0145264,7 L13.033997,6.99997787 C12.2323127,7.00531181 12,7.23938704 12,8.04272461 L12,9.02941895 Z"
              id="trash-Path-5"
              fill="#fff"
            ></path>
            <rect
              id="trash-Rectangle-2"
              fill="#fff"
              x="7"
              y="8"
              width="14"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="trash-Rectangle-3"
              fill="#fff"
              x="11"
              y="11"
              width="2"
              height="8"
              rx="1"
            ></rect>
            <rect
              id="trash-Rectangle-3-Copy"
              fill="#fff"
              x="15"
              y="11"
              width="2"
              height="8"
              rx="1"
            ></rect>
            <g></g>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="image-file-icon" viewBox="0 0 24 24">
    <g
      id="icons-/-24-/-Document-Jpeg"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="Bounding-box" x="0" y="0" width="24" height="24"></rect>
      <path
        d="M22,4 L22,20 L2,20 L2,4 L22,4 Z M20,6 L4,6 L4,18 L20,18 L20,6 Z"
        id="Combined-Shape"
        fill="#162D3D"
      ></path>
      <polyline
        id="Line"
        stroke="#162D3D"
        stroke-width="2"
        points="3.04858398 17.03125 8 13 11.0153809 15.0305176 16.0131836 9.92626953 21.1008301 16.1101074"
      ></polyline>
      <rect
        id="Rectangle"
        fill="#162D3D"
        x="6"
        y="8"
        width="2"
        height="2"
      ></rect>
    </g>
  </symbol>
  <symbol id="pdf-file-icon" viewBox="0 0 24 24">
    <g
      id="icons-/-24-/-Document-PDF"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="Bounding-box" x="0" y="0" width="24" height="24"></rect>
      <path
        d="M14,2 L20,8 L20,22 L4,22 L4,2 L14,2 Z M13.171,4 L6,4 L6,20 L18,20 L18,8.829 L13.171,4 Z"
        id="Rectangle"
        fill="#162D3D"
      ></path>
      <line
        x1="9.35"
        y1="15.6"
        x2="12.15"
        y2="12.4"
        id="Line-2"
        stroke="#162D3D"
        stroke-width="2"
        stroke-linecap="square"
      ></line>
      <line
        x1="12.15"
        y1="12.6666667"
        x2="11.1"
        y2="9"
        id="Line-2-Copy-2"
        stroke="#162D3D"
        stroke-width="2"
        stroke-linecap="square"
      ></line>
      <line
        x1="12.15"
        y1="12.5"
        x2="14.95"
        y2="14"
        id="Line-2-Copy"
        stroke="#162D3D"
        stroke-width="2"
        stroke-linecap="square"
      ></line>
    </g>
  </symbol>
</svg>

<div class="file-item">
  <span class="file-title" (click)="clickFile.emit(fileId)">
    <i2g-icon
      class="file-item-icon"
      [icon]="fileType === 'application/pdf' ? pdfIcon : imageIcon"
    ></i2g-icon>
    {{ fileName }}
  </span>
  <span
    *ngIf="showDeleteButton"
    class="delete-icon"
    (click)="deleteFile.emit(fileId)"
    ><i2g-icon [icon]="deleteIcon"></i2g-icon
  ></span>
</div>
